module.exports = __webpack_public_path__ + "static/media/equal-circle.29841a15.svg";